
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/forgot-password",
      function () {
        return require("private-next-pages/partner/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/forgot-password"])
      });
    }
  